// Voice equalizer bars (F-CALL, design "speaking indicator"). Four CSS-animated
// bars, gated by a single `active` flag (isSpeaking) — no per-frame JS, so idle
// instances cost nothing (§9.3). Positioning is the caller's job: pass a
// className (e.g. tile corner, or the mic-pill lead slot).

import { memo } from 'react';

export const EqualizerBars = memo(function EqualizerBars({
  active,
  className,
  bars = 4,
}: {
  active: boolean;
  className?: string;
  /** Bar count — tiles use 4; the compact mic-pill meter uses 3. */
  bars?: number;
}) {
  return (
    <span
      className={`bz-eq${active ? ' bz-eq-on' : ''}${className ? ` ${className}` : ''}`}
      aria-hidden="true"
    >
      {Array.from({ length: bars }, (_, i) => (
        <i key={i} />
      ))}
    </span>
  );
});
